import axios from "axios";

const mongoCall = axios.create({
    baseURL: import.meta.env.REACT_APP_MONGO_API_DOMAIN,
    timeout: 90000,
});

export default mongoCall;
